<template>
  <Dialog
    :visible.sync="display"
    :style="{ width: '90vw' }"
    :modal="true"
    :closable="false"
  >
  <template #header>
    <span>{{$t("Workday.EndTimeDialog")}}</span>
  </template>
     <div class="div-field">
        {{ $t("WorkRegistrationForm.EndTime") }}
      <datetime
        v-bind:type="isEnabledMidnightOption() ? 'datetime' : 'time'"       
        v-model="selectedEndTime"
        v-bind:format="isEnabledMidnightOption() ? 'dd/HH:mm' : 'HH:mm'"
        input-style="text-align:center"
        class="theme-blue"
        v-bind:backdrop-click="false"
        :min-datetime="minDatetime"
        :max-datetime="maxDatetime"
      >
      </datetime>
    </div>

    <template #footer>
      <Button
        :label="$t('Confirmation.Yes')"
        icon="pi pi-check"
        @click="confirmDateTime()"
      />
      <Button
        :label="$t('Confirmation.Cancel')"
        icon="pi pi-times"
        @click="display=false"
        class="p-button-secondary"
      />
    </template>
     </Dialog>
</template>

<script>
import moment from "moment";
export default {
  name: "WorkRegistrationEndTimeDialog",
    props: { 
    display: {
    type: Boolean,
    default: false
  },},
  data() {
    return {      
      selectedEndTime: null,
      minDatetime: null,
      maxDatetime: null,
    };
  },
  created() {
    
  },
  mounted() {
    this.selectedEndTime = this.$route.query.workDate;
    this.minDatetime = this.$route.query.workDate;
    this.maxDatetime = moment(this.$route.query.workDate)
      .add(1, "days")
      .add(23, "hours")
      .add(59, "minutes")
      .format("YYYY-MM-DD[T]HH:mm:00");
  },
  methods: {
    onClick(value) {
      this.$emit("confirmed", value);
    },
    isEnabledMidnightOption(){
        return false;
    },
    confirmDateTime(){
        this.$emit("confirmed", {
          value: this.selectedEndTime,
        });
    }
  },
};
</script>
